import React, {useState} from "react";

import styles from "../../styles/Profile.module.css";

export default function Profile(props: ProfileProps) {
    const [avatarError, setAvatarError] = useState(false);
    const username = [
        props.user.lastname,
        props.user.firstname ? `${props.user.firstname[0]}.` : '',
        props.user.middlename ? `${props.user.middlename[0]}.` : '',
    ].filter((el) => el.length);

    return (
        <div className={styles.user}>
            {props.user.avatar && avatarError ? (
                <img
                    src={props.user.avatar}
                    alt=""
                    className={styles.userAvatar}
                    onError={() => setAvatarError(true)}
                />
            ) : (
                <div className={styles.avatar}>
                    {username
                        .map((el) => el.charAt(0).toUpperCase())
                        .join("")
                        .substring(0, 2)}
                </div>
            )}
            <div className={styles.username}>
                {props.user.company === "" ? (
                    <p>{props.user.login}</p>
                ) : (
                    <p>{props.user.company.title}</p>
                )}
                <p>{username.join(" ")}</p>
            </div>
            {props.children}
        </div>
    );
}
